import { ResourceDto, ResourceGroupDto } from 'types';

export interface IGroupResource extends ResourceGroupDto {
  label: string;
  value: string;
  resources: ResourceDto[];
}

export type WebhookHttpMethod = 'POST' | 'PUT' | 'PATCH';

export const WEBHOOK_HTTP_METHODS: WebhookHttpMethod[] = ['POST', 'PUT', 'PATCH'];

export type WebhookEventType =
  | 'WORK_ORDER_MARKED_READY'
  | 'CONTAINER_NUMBER_ADDED'
  | 'CONTAINER_NUMBER_UPDATED'
  | 'CONTAINER_NUMBER_DUPLICATED';

export const WEBHOOK_EVENTS: { value: WebhookEventType; label: string }[] = [
  { value: 'WORK_ORDER_MARKED_READY', label: 'Work Order marked READY' },
  { value: 'CONTAINER_NUMBER_ADDED', label: 'Container number added' },
  { value: 'CONTAINER_NUMBER_UPDATED', label: 'Container number updated' },
  {
    value: 'CONTAINER_NUMBER_DUPLICATED',
    label: 'Container number duplicated',
  },
];

export const WEBHOOK_EVENT_LABELS: Record<WebhookEventType, string> = {
  WORK_ORDER_MARKED_READY: 'Work Order marked READY',
  CONTAINER_NUMBER_ADDED: 'Container number added',
  CONTAINER_NUMBER_UPDATED: 'Container number updated',
  CONTAINER_NUMBER_DUPLICATED: 'Container number duplicated',
};

export interface IUserSnapshot {
  _id: string;
  fullName: string;
}

export interface IWebhookDto {
  _id: string;
  name: string;
  url: string;
  method: WebhookHttpMethod;
  events: WebhookEventType[];
  isActive: boolean;
  createdBy?: IUserSnapshot;
  updatedBy?: IUserSnapshot;
  createdAt?: string;
  updatedAt?: string;
}

export interface ICreateWebhookDto {
  name: string;
  url: string;
  method: WebhookHttpMethod;
  events: WebhookEventType[];
  isActive: boolean;
}

export interface IUpdateWebhookDto {
  name?: string;
  url?: string;
  method?: WebhookHttpMethod;
  events?: WebhookEventType[];
  isActive?: boolean;
}
